import { Header, Icon, Modal } from 'semantic-ui-react';

import {
  CORTEX_CLIENT_SUPPORT_DESCRIPTION,
  CORTEX_CLIENT_SUPPORT_LABEL,
  CORTEX_CLIENT_URL,
  DOWNLOAD_USER_GUIDE_LABEL,
  DOWNLOAD_USER_GUIDE_TITLE,
  HELP_MODAL_TITLE,
} from '../MainHeader.constants';

interface HelpModalProps {
  userGuideUrl: string;
}

const HelpModal = ({ userGuideUrl }: HelpModalProps) => {
  return (
    <Modal
      trigger={
        <Icon aria-label='help' name='help' style={{ cursor: 'pointer' }} />
      }
      centered={false}
    >
      <Modal.Header icon='help' content={HELP_MODAL_TITLE}></Modal.Header>
      <Modal.Content>
        <Header size='large'>
          <br />
          <a
            href={userGuideUrl}
            title={DOWNLOAD_USER_GUIDE_TITLE}
            target='_blank'
            rel='noopener noreferrer'
          >
            {DOWNLOAD_USER_GUIDE_LABEL}
          </a>
        </Header>
        <br />
        <Header size='medium'>
          {CORTEX_CLIENT_SUPPORT_DESCRIPTION}
          <a target='_blank' rel='noopener noreferrer' href={CORTEX_CLIENT_URL}>
            {CORTEX_CLIENT_SUPPORT_LABEL}
          </a>
        </Header>
        <br />
      </Modal.Content>
    </Modal>
  );
};

export default HelpModal;
